import { render } from "./distribution.vue?vue&type=template&id=187f0dc1&scoped=true&ts=true&lang=pug"
import script from "./distribution.vue?vue&type=script&lang=ts"
export * from "./distribution.vue?vue&type=script&lang=ts"

import "./distribution.vue?vue&type=style&index=0&id=187f0dc1&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187f0dc1"]])

export default __exports__